import { SearchableMenuBody } from './SearchableMenuBody';
import { SearchableMenuPopover } from './SearchableMenuPopover';
import { SearchableMenuProvider } from './SearchableMenuProvider';
import { SearchableMenuSearchHeader } from './SearchableMenuSearchHeader';
import { useSearchableMenuFuse } from './useSearchableMenuFuse';
/**
 * A flexible, searchable dropdown menu component that uses Fuse.js for fast in-memory fuzzy searching.
 */
export function SearchableMenu(props) {
    const { renderTarget, items, keys, placeholder, children, initiallyOpen = false, onClose, fuseOptions, useTargetWidth, } = props;
    const search = useSearchableMenuFuse(items, Object.assign({ keys }, fuseOptions));
    return (<SearchableMenuProvider initiallyOpen={initiallyOpen} onClose={onClose} {...search}>
      <SearchableMenuPopover renderTarget={renderTarget} useTargetWidth={useTargetWidth}>
        <SearchableMenuSearchHeader placeholder={placeholder}/>
        <SearchableMenuBody>{children}</SearchableMenuBody>
      </SearchableMenuPopover>
    </SearchableMenuProvider>);
}
